import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lighten } from 'polished';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 10px;
  padding-left: 0;
  margin-right: 10px;
  outline: 0;

  * {
    color: ${props => (props.isActive ? lighten(1, props.textColor) : props.textColor)};
    opacity: ${props => (props.isActive ? 1 : '.5')};
  }

  span {
    border-bottom: ${props => (props.isActive ? '0' : '1px dotted #fff')}
  }
`;

class Tab extends React.Component {
  static propTypes = {
    titleContent: PropTypes.node.isRequired,
    textColor: PropTypes.string,
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    isActive: PropTypes.bool,
    activeTabIcon: PropTypes.node,
    onClickWhenActive: PropTypes.func,
  }

  static defaultProps = {
    onClick: null,
    tabIndex: null,
    isActive: null,
    textColor: '#777',
    activeTabIcon: null,
    onClickWhenActive: () => null,
  }

  render() {
    return (
      <li>
        <StyledButton
          {...this.props}
          onClick={(event) => {
            event.preventDefault();
            if (this.props.isActive) {
              this.props.onClickWhenActive();
            } else {
              this.props.onClick(this.props.tabIndex);
            }
          }}
        >
          {this.props.titleContent}
          {this.props.isActive && this.props.activeTabIcon}
        </StyledButton>
      </li>
    );
  }
}

export default Tab;
